import script from "./TrainBottomSkeleton.vue?vue&type=script&setup=true&lang=ts"
export * from "./TrainBottomSkeleton.vue?vue&type=script&setup=true&lang=ts"

import "./TrainBottomSkeleton.vue?vue&type=style&index=0&id=c5a59ed4&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1212641435/src/bitbucket.org/labtravelfactory/booking-funnel-xftless/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5a59ed4"]])

export default __exports__